module.exports = __webpack_public_path__ + "img/orange-and-red-lily.3e4271c8.jpg";